import React from 'react'
import { ToolTip, Button, Form } from '@drifthq/tide-core'
import cx from 'classnames'
import { ReCaptcha } from 'react-recaptcha-google'
import { Link } from 'react-router-dom'
import { parse } from 'query-string'

import { isValid } from 'utils/password'
import EmailInput from 'components/EmailInput'
import Consent from 'components/Consent'
import PasswordInput from 'components/PasswordInput'
import { DynamicNotification } from 'components/DynamicNotification'
import { track } from 'utils/trackingUtils'

const trackFindMyTeamNotification = () => {
  track('Onboarding Find My Team Triggered', {
    context: 'notification triggered'
  })
}

export const INVALID_DOMAINS = [
  '@gmail.',
  '@yahoo.',
  '@hotmail.',
  '@live.',
  '@aol.',
  '@outlook.',
  '@comcast.',
  '@inbox.',
  '@icloud.',
  '@mail.com'
]

const SignupCard = ({
  email,
  password,
  onEmailChange,
  onPasswordChange,
  onContinueClick,
  onFindMyTeamClick,
  disabledEmail,
  validEmail,
  isGdprConsentRequired,
  isGdprConsentGranted,
  setGdprConsentGranted,
  createOrgLoading,
  checkEmailIsSSOEnabledPending,
  splitLoading,
  hideError,
  createOrgError,
  verifyCallback,
  setVerifyCallback,
  setRecaptchaReference,
  onProcessingGoogleCode,
  domainFound,
  search,
  hideRecaptcha
}) => {
  const errorState = (!hideError && (!!createOrgError || !validEmail)) ? "touchless-email-input-error" : ""
  const emailDisplay = disabledEmail ? "touchless-email-input-disable" : ""
  const displayToolTip = INVALID_DOMAINS.some(domain => email.includes(domain))

  const { plan } = parse(search)
  const headerCopy = plan ? "Create your Drift account" : "Create your free Drift account"
  return (
    <Form className="touchless-start-fields" onSubmit={onContinueClick}>
      <h1 className="touchless-start-header">{headerCopy}</h1>
      <ToolTip
        className="touchless-start-tooltip"
        open={displayToolTip}
        hover={displayToolTip}
        flow='right'
        render={() => "We recommend using a work email in order to get the most out of Drift"}
      />
      <EmailInput
        placeholder="Enter your work email"
        className={cx(`${errorState}`, `${emailDisplay}`, "touchless-email-input")}
        onChange={onEmailChange}
        value={email}
        hideError={hideError}
        createOrgError={createOrgError}
        valid={validEmail}
        unique={!createOrgError}
        disabled={disabledEmail}
        type={"text"}
      />
      {domainFound && <DynamicNotification type="findMyTeam" onClick={onFindMyTeamClick} onTrack={trackFindMyTeamNotification}/> }
      <PasswordInput
        value={password}
        onChange={onPasswordChange}
        label={null}
        experiment={true}
      />
      { !hideRecaptcha  &&
          <ReCaptcha
            className="touchless-start-recaptcha"
            size="normal"
            theme="light"
            render="explicit"
            sitekey="6Lf5Zp4UAAAAAPS0kKChVRRgB6HfDxkZtFr-OhF1"
            onloadCallback={setRecaptchaReference}
            verifyCallback={setVerifyCallback}
          />
      }
      <Button
        submit
        size="large"
        disabled={!isValid({ password: password }) || !email || (isGdprConsentRequired && !isGdprConsentGranted) || (!verifyCallback && !hideRecaptcha)}
        loading={createOrgLoading || checkEmailIsSSOEnabledPending || splitLoading}
      >
        Create free account
      </Button>
      { isGdprConsentRequired &&
          <Consent
            checked={isGdprConsentGranted}
            onChange={() => setGdprConsentGranted(!isGdprConsentGranted)}
          />
      }
      { !disabledEmail && !isGdprConsentRequired &&
          <p className="touchless-start-fields-auth">
            Sign up with
            <Link className="touchless-start-link" to="/start">Google or Microsoft </Link>
          </p>
      }
    </Form>
  )
}

export default SignupCard



// WEBPACK FOOTER //
// ./src/layouts/SignupCard/component.js